export default __webpack_public_path__ + "static/media/m_slide_btn_right.5f053c72.png";